export default [
    {
        id: 'geo-record-points',
        type: 'circle',
        source: 'geo-records',
        paint: {
            'circle-radius': [
                'interpolate',
                ['exponential', 0.5],
                ['zoom'],
                10,
                1,
                20,
                3,
            ],
            'circle-color': ['get', 'color'],
            'circle-stroke-color': '#ffffff',
            'circle-stroke-width': [
                'case',
                ['boolean', ['feature-state', 'hover'], false],
                3,
                1,
            ],
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'Point'],
        ],
        minzoom: 12,
    },
    {
        id: 'transparent-geo-record-point',
        type: 'circle',
        source: 'geo-records',
        paint: {
            'circle-radius': 10,
            'circle-color': 'rgba(255,255,255,0)',
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'Point'],
        ],
        minzoom: 12,
    },
    {
        id: 'geo-record-linestring',
        type: 'line',
        source: 'geo-records',
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
        },
        paint: {
            'line-color': [
                'case',
                ['boolean', ['feature-state', 'hover'], false],
                '#ffffff',
                ['get', 'color'],
            ],
            'line-width': [
                'case',
                ['boolean', ['feature-state', 'hover'], false],
                5,
                1,
            ],
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'LineString'],
        ],
        minzoom: 12,
    },
    {
        id: 'transparent-geo-record-linestring',
        type: 'line',
        source: 'geo-records',
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
        },
        paint: {
            'line-color': [
                'case',
                ['boolean', ['feature-state', 'hover'], false],
                'rgba(255, 255, 255, 0)',
                'rgba(255, 255, 255, 0)',
            ],
            'line-width': 20,
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'LineString'],
        ],
        minzoom: 12,
    },
    {
        id: 'geo-record-polygon-outline',
        type: 'line',
        source: 'geo-records',
        paint: {
            'line-color': ['get', 'color'],
            'line-width': 1,
            'line-opacity': [
                'case',
                ['boolean', ['feature-state', 'hover'], false],
                0.7,
                [
                    'case',
                    ['has', ['get', 'id']],
                    ['coalesce', ['get', 'opacity'], 0.4],

                    0.4,
                ],
            ],
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'Polygon'],
        ],
        minzoom: 12,
    },
    {
        id: 'geo-record-polygon',
        type: 'fill',
        source: 'geo-records',
        paint: {
            'fill-color': [
                'case',
                ['boolean', ['get', 'isFill'], false],
                ['get', 'color'],
                'transparent',
            ],
            'fill-opacity': [
                'case',
                ['boolean', ['feature-state', 'hover'], false],
                0.8,
                ['coalesce', ['get', 'opacity'], 0.5],
            ],
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'Polygon'],
        ],
        minzoom: 12,
    },
    {
        id: 'geo-record-state-linestring',
        type: 'line',
        source: 'geo-records',
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
        },
        paint: {
            'line-color': ['get', 'color'],
            'line-width': 2,
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'LineString'],
        ],
        minzoom: 12,
    },
    {
        id: 'highlighted',
        type: 'fill',
        source: 'geo-records',
        paint: {
            'fill-outline-color': '#484896',
            'fill-color': '#6e599f',
            'fill-opacity': [
                'case',
                ['boolean', ['feature-state', 'hover'], false],
                1,
                0,
            ],
        },
        filter: ['all', ['in', 'FIPS', '']],
        minzoom: 12,
    },
    {
        id: 'geo-record-title',
        type: 'symbol',
        source: 'geo-records',
        layout: {
            'symbol-placement': 'point',
            'text-field': ['get', 'title'],
            'text-size': 13,
        },
        paint: {
            'text-color': '#eee',
            'text-halo-color': 'rgba(0,0,0,0.6)',
            'text-halo-width': 1.5,
        },
        style: {
            glyphs: '',
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['get', 'labelState'], 'on'],
        ],
        minzoom: 16,
    },
    {
        id: 'geo-record-line-measurement',
        type: 'symbol',
        source: 'geo-records-vertex-label',
        layout: {
            'symbol-placement': 'line-center',
            'text-field': ['get', 'title'],
            'text-size': 11,
            'icon-allow-overlap': true,
            'symbol-spacing': 150,
            'text-pitch-alignment': 'viewport',
            'text-rotation-alignment': 'viewport',
        },
        paint: {
            'text-color': '#eee',
            'text-halo-color': 'rgba(0,0,0,0.6)',
            'text-halo-width': 1.5,
        },
        style: {
            glyphs: '',
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['get', 'vertexLabelState'], 'on'],
        ],
        minzoom: 16,
    },
    {
        id: 'geo-record-points-archive',
        type: 'circle',
        source: 'geo-records-archive',
        paint: {
            'circle-radius': [
                'interpolate',
                ['exponential', 0.5],
                ['zoom'],
                10,
                1,
                20,
                3,
            ],
            'circle-color': ['get', 'color'],
            'circle-stroke-color': '#ffffff',
            'circle-stroke-width': 0.4,
            'circle-opacity': 0.4,
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'Point'],
        ],
        minzoom: 12,
    },
    {
        id: 'geo-record-linestring-archive',
        type: 'line',
        source: 'geo-records-archive',
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
        },
        paint: {
            'line-color': ['get', 'color'],
            'line-width': 1,
            'line-opacity': 0.4,
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'LineString'],
        ],
        minzoom: 12,
    },
    {
        id: 'geo-record-polygon-outline-archive',
        type: 'line',
        source: 'geo-records-archive',
        paint: {
            'line-color': ['get', 'color'],
            'line-width': 1,
            'line-opacity': 0.4,
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'Polygon'],
        ],
        minzoom: 12,
    },
    {
        id: 'geo-record-polygon-archive',
        type: 'fill',
        source: 'geo-records-archive',
        paint: {
            'fill-color': [
                'case',
                ['boolean', ['get', 'isFill'], false],
                ['get', 'color'],
                'transparent',
            ],
            'fill-opacity': 0.4,
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'Polygon'],
        ],
        minzoom: 12,
    },
    {
        id: 'geo-record-state-linestring-archive',
        type: 'line',
        source: 'geo-records-archive',
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
        },
        paint: {
            'line-color': ['get', 'color'],
            'line-width': 2,
            'line-opacity': 0.4,
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'LineString'],
        ],
        minzoom: 12,
    },
    {
        id: 'geo-record-title-archive',
        type: 'symbol',
        source: 'geo-records-archive',
        layout: {
            'symbol-placement': 'point',
            'text-field': ['get', 'title'],
            'text-size': 13,
        },
        paint: {
            'text-color': '#eee',
            'text-halo-color': 'rgba(0,0,0,0.6)',
            'text-halo-width': 1.5,
        },
        style: {
            glyphs: '',
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['get', 'labelState'], 'on'],
        ],
        minzoom: 16,
    },
];
